import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ContactPopup from "./components/ContactPopup";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Header openPopup={openPopup} />
          <Routes>
            <Route path="/" element={<Home openPopup={openPopup} />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
          </Routes>
          <Footer />
          <ContactPopup isOpen={isPopupOpen} onClose={closePopup} />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
